export const STICKY_QUERY_KEYS = ['referral', 'program', 'course'];

function isValidId(id) {
    if (id === undefined || id === null || id === '') {
        return false;
    }
    const value = String(id);
    return value.length > 0 && !/[/?]/.test(value);
}

export function pickStickyQuery(query) {
    if (!query) {
        return {};
    }
    const result = {};
    STICKY_QUERY_KEYS.forEach((key) => {
        if (query[key] !== undefined && query[key] !== null && query[key] !== '') {
            result[key] = query[key];
        }
    });
    return result;
}

export function mergeStickyQuery(toQuery, fromQuery) {
    if (!fromQuery) {
        return null;
    }
    const query = Object.assign({}, toQuery || {});
    let changed = false;
    STICKY_QUERY_KEYS.forEach((key) => {
        if (fromQuery[key] && !query[key]) {
            query[key] = fromQuery[key];
            changed = true;
        }
    });
    return changed ? query : null;
}

export function resolveTargetRoute(query) {
    if (!query) {
        return null;
    }
    if (isValidId(query.program)) {
        return { name: 'program', params: { id: String(query.program) } };
    }
    if (isValidId(query.course)) {
        return { name: 'course', params: { id: String(query.course) } };
    }
    return null;
}
